import React, { useState, useCallback } from "react";
import { RendererProps } from "./index";
import { TextArea } from "./renderer-styles";

const ParagraphInputRenderer: React.FC<RendererProps> = ({
  question,
  answer,
  onAnswer,
}) => {
  const [value, setValue] = useState<string>(answer?.value ?? "");

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLTextAreaElement>) => {
      const val = e.target.value;
      setValue(val);
      const isValid = question.required ? val.trim().length > 0 : true;
      onAnswer(val, isValid);
    },
    [onAnswer, question.required]
  );

  return (
    <TextArea
      value={value}
      onChange={handleChange}
      placeholder={question.placeholder || ""}
    />
  );
};

export default ParagraphInputRenderer;
